import { render, staticRenderFns } from "./PsHome.vue?vue&type=template&id=13f850e2&scoped=true&"
import script from "./PsHome.vue?vue&type=script&lang=js&"
export * from "./PsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f850e2",
  null
  
)

export default component.exports